export default __webpack_public_path__ + "static/media/risk1.660131a0.jpg";